var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "arrow-very-bullish",
    width: 11.412,
    height: 6.848,
    viewBox: "0 0 11.412 6.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M13.36,6.354A.579.579,0,0,0,12.835,6H9.983a.57.57,0,1,0,0,1.141h1.477L8.272,10.329,6.4,8.447a.57.57,0,0,0-.81,0L2.163,11.87a.573.573,0,1,0,.81.81L5.99,9.656l1.877,1.882a.57.57,0,0,0,.81,0l3.588-3.594V9.422a.57.57,0,0,0,1.141,0V6.57A.57.57,0,0,0,13.36,6.354Z",
    transform: "translate(-1.994 -6)",
    fill: "#13C85B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.7a5b39abb11b851aa44c13a23a4ae946.svg";
export { ForwardRef as ReactComponent };